<template>
	<div class="pages">
		<van-form @submit="onSubmit">
			<van-field v-model="roomNum" name="所选房间号" label="所选房间号" placeholder="填写联系人" disabled />

			<van-field v-model="startTime" name="入住日期" label="入住日期" placeholder="选择入住日期" @click="showStartTime = true"
				readonly :rules="[{ required: true, message: '选择入住日期' }]" />
			<van-field v-model="endTime" name="离开日期" label="离开日期" placeholder="选择离开日期" @click="showEndTime = true"
				readonly :rules="[{ required: true, message: '选择离开日期' }]" />


			<div style="margin: 16px">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<van-calendar v-model="showStartTime" @confirm="onConfirmStartTime" />
		<van-calendar v-model="showEndTime" @confirm="onConfirmEndTime" />
	</div>
</template>
<script>
	import {
		addRoom
	} from "../../apis/api";
	import {
		Toast,
		Dialog
	} from "vant";
	export default {
		data() {
			return {
				startTime: '',
				endTime: '',
				roomNum: '',
				showStartTime:false,
				showEndTime:false,
				id:''
		

			};
		},
		mounted() {
			document.title = "宿舍预约";
			// get room number
			this.roomNum = this.$route.query.roomNum;
			this.id = this.$route.query.id
		},
		methods: {
			formatDate(date) {
			      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			    },
			  
			onConfirmStartTime(date){
				
				this.startTime = this.formatDate(date);
				this.showStartTime = false;
			},
			onConfirmEndTime(date){
				this.endTime  =this.formatDate((date));
				this.showEndTime = false;
			},
			onSubmit(values) {
				addRoom({
					entryTime: this.startTime,
					leaveTime: this.endTime,
					openId: localStorage.getItem("openId"),
					roomId: this.id,
				}).then((res) => {
					
					Toast(res.message);
					this.$router.go(-1)
					
				});;
				
			},
		},
	};
</script>
<style lang="less" scoped>
	.pages {
		padding: 20px;
	}
</style>
